export default "/images/26f2baabbe0f66000a74b0996fbdd95a.png";